import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformAuthAvailabilityApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/agency-users`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static checkUserNameAvailability(body: string): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/userName-availability`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static checkEmailAvailability(body: string): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/email-availability`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}
}

export default PlatformAuthAvailabilityApiService;
